import React from 'react';

export const renderCartaPorte = (headers, data, checkbox, openDetails) => {

    return renderTable(headers, data, checkbox, openDetails);

}

const renderTable = (headers, data, checkbox, openDetails) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            <td className="sticky-column" style={{ backgroundColor: "#e9ecef" }}>
                <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" value="second_checkbox" onChange={(event) => checkbox.selectAll(event.target.checked)} />
            </td>
            {headers[0].value && <td>{headers[0].title}</td>}
            {headers[1].value && <td>{headers[1].title}</td>}
            {headers[2].value && <td>{headers[2].title}</td>}
            {headers[3].value && <td>{headers[3].title}</td>}
            {headers[4].value && <td>{headers[4].title}</td>}
            {headers[5].value && <td>{headers[5].title}</td>}
            {headers[6].value && <td>{headers[6].title}</td>}
            {headers[7].value && <td>{headers[7].title}</td>}
            {headers[8].value && <td>{headers[8].title}</td>}
            {headers[9].value && <td>{headers[9].title}</td>}
            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>

        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDetails);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};


const renderTableBody = (headers, data, checkbox, openDetails) => {
    let body = "";
    body = data.map((register, index) => {
        if (register.statusBorrador !== 'W' && register.statusBorrador !== 'Y') {
            let fontColor = 'black'
            if (register.CancelRequest && register.CancelRequest === 'Y') { fontColor = 'red'; }
            return (
                <tr key={index}>
                    <td className="sticky-column" >
                        <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)} />
                    </td>
                    {headers[0].value && <td>{register.CodigoCarta}</td>}
                    {headers[1].value && <td style={{ color: fontColor }}>{register?.U_FMB_UUID !== null ? 'Timbrado' : 'Sin timbrar'}</td>}
                    {headers[2].value && <td>{register.ObjType === 'I' ? 'INGRESO' : 'TRASLADO'}</td>}
                    {headers[3].value && <td>{register.Version}</td>}
                    {headers[4].value && <td>{register.DocNum}</td>}
                    {headers[5].value && <td>{register.CardCode}</td>}
                    {headers[6].value && <td>{(register.TipoTransporte ? register.TipoTransporte : '') + '-' + (register.Transporte ? register.Transporte : '')}</td>}
                    {headers[7].value && <td>{register.FiguraTransporte}</td>}
                    {headers[8].value && <td>{register?.CreateUser ?? ''}</td>}
                    {headers[9].value && <td>{register.Folio ?? ''}</td>}
                    <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                        <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                            onClick={() => openDetails({ Code: register.CodigoCarta, index })}
                            style={{ fontWeight: '500' }}>
                            <i className="far fa-file-alt">
                            </i> Ver Detalles
                        </button>
                    </td>
                </tr>
            )
        }
    })
    return body;
};


